import React from "react";
import { useNavigate } from "react-router-dom";
import "./EnterPage.css";
import dbzsAudio from "../assets/dbzs.mp3";

function EnterPage() {
    const navigate = useNavigate();

    const handleEnter = () => {
        // Start audio track
        const audio = new Audio(dbzsAudio);
        audio.volume = 0.7;
        audio.loop = true;
        audio.play().catch(error => console.log("Audio play failed:", error));
        // Store audio reference globally so it can be stopped later
        window.currentAudio = audio;
        navigate("/radar");
    };

    return (
        <div className="enter-page">
            <button className="enter-button" onClick={handleEnter}>
                ENTER
            </button>
        </div>
    );
}

export default EnterPage;
